<template>
  <Layout active="shared_reports" hide-logout="true" title="Shared With Me">
    <template v-slot:main-btn >

    </template>

      <Loading :loading="loading">
          <table class="table falcon-table">
            <thead>
            <tr>
              <th>
                Date
              </th>
              <th>
                Owner
              </th>
              <th>
                Name
              </th>
              <th>
                Pre-Money Valuation
              </th>
              <th>
                Capital Needed
              </th>
              <th>
                Investor %
              </th>
              <th></th>
            </tr>
            </thead>

            <tbody>
            <tr v-if="reports.length === 0">
              <td colspan="6">
                No reports found.
              </td>
            </tr>
            <tr v-for="reportData in reports">
              <td>
                {{ reportData.report.created | moment("YYYY-MM-DD") }}
              </td>
              <td>
                {{ reportData.user.first_name }} {{ reportData.user.last_name }}
              </td>
              <td>
                <span v-if="!reportData.report.is_light">{{ reportData.report.startup_name }}</span>
                <span v-if="reportData.report.is_light">{{ reportData.report.label }}</span>
              </td>
              <td>
                <span v-if="reportData.report.status !== 'unlocked'">
                   <upgrade-action redirect-to="new-valuation">
                        <a  href="#" @click.prevent :to="{'name': 'calculator'}">
                          Unlock
                        </a>
                      </upgrade-action>
                </span>
                <span v-if="reportData.report.status === 'unlocked'"> {{ reportData.report.avg_valuation|formatDollarsNoZeros }}</span>

              </td>
              <td>
                {{ reportData.report.useoffund.requested_fund }}
                <span v-if="reportData.report.is_light"> -- </span>
              </td>
              <td>
                {{ reportData.report.useoffund.in_return_for }}%
                <span v-if="reportData.report.is_light">--</span>
              </td>
              <td>
                <div class="sep-16"></div>
                <div class="sep-8"></div>
                 <button @click="goToResults(reportData.report)" class="button is-primary">
                    View Report
                 </button>
              </td>
            </tr>

            </tbody>
          </table>
        </Loading>

  </Layout>
</template>


<script>
import Layout from "../../../shared/components/Layout";
import Loading from "../../../shared/components/Loading";
import {ReportAPI} from "../../../apis/ReportAPI";
import {mapGetters} from "vuex";
import UpgradeAction from "@/shared/components/UpgradeAction";
import CalculatorMixin from "@/modules/calculator/mixins";

export default {
  name: "SharedReports",
  components: {Layout, Loading, UpgradeAction},
  mixins: [CalculatorMixin],
  data() {
    return {
      'reports': [],
      'activeTab': 0,
      'loading': false,
    }
  },
  async mounted() {
    this.loading = true;
    this.reports = await ReportAPI.listSharedReports();
    this.loading = false;
    SFAnalytics.track('Shared With Me Page Viewed Valuation');
  },
  methods: {
    goToResults(report) {
      this.$router.push({'name': 'view_shared_report', 'params': {'id': report.id}});
    },
    onTabChange(tab){
      // if( tab === 0){
      //   SFAnalytics.track('Dashboard Valuations Page Viewed Valuation');
      // }
      // else {
      //   SFAnalytics.track('Dashboard Valuations Page Viewed Light Valuation');
      // }
    }
  },
  computed: {
    subscriptionDetails() {
      return this.$store.state.account.subscriptionDetails;
    },
    creditsDetails() {
      return this.$store.state.account.creditsDetails;
    },
    ...mapGetters('account', [
      'hasCredits',
    ])
  }
}
</script>

<style lang="scss" scoped>
table {
  thead {
    background-color: #f3f3f3;
  }
  td,tr th:not([align]) {
    text-align: center;
  }
}
</style>
